import request from './request';

export const maxRegisterApi = {
  getMxwPkgInfo() {
    return request({
      url: '/auth/get/mxw-package',
      method: 'get',
      params: {
        type: 'MXW_WALLET_WEB',
      },
    });
  },
  loginWithMaxWallet(data) {
    return request({
      url: '/auth/max-wallet/login',
      method: 'post',
      data: {
        data,
      },
    });
  },
  registerWithMaxWallet(data, inviteCode) {
    return request({
      url: '/max/register',
      method: 'post',
      data: {
        data,
        refCode: inviteCode
      },
    });
  },
  performKycWithMaxWallet(data) {
    return request({
      url: '/kyc/set/primary',
      method: 'post',
      data,
    });
  },
  bindMaxWallet(data) {
    return request({
      url: '/user/bind/max-wallet',
      method: 'post',
      data: {
        data,
      },
    });
  }
};
